<div class="procesar-pago">
    <div class="center">
        <div class="loading-pago">
            <mat-spinner></mat-spinner>
        </div>
        <h1>Por favor espera hasta que el pago sea procesado...</h1>
    </div>
</div>